/**
 * Smooth Scroll pour les liens ancre
 * Anime le défilement vers les sections avec un effet fluide
 */
document.addEventListener("DOMContentLoaded", function () {
  // Configuration
  const CONFIG = {
    offset: 0, // Offset pour la navbar fixe (ajuster selon la hauteur de votre navbar)
    duration: 800, // Durée de l'animation en ms
    easing: "easeInOutCubic", // Type d'easing
  };

  // Fonctions d'easing
  const easings = {
    linear: (t) => t,
    easeInQuad: (t) => t * t,
    easeOutQuad: (t) => t * (2 - t),
    easeInOutQuad: (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t),
    easeInCubic: (t) => t * t * t,
    easeOutCubic: (t) => --t * t * t + 1,
    easeInOutCubic: (t) =>
      t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
    easeOutExpo: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
  };

  /**
   * Animation de scroll vers une position
   */
  function smoothScrollTo(targetPosition, duration, easingName) {
    const startPosition = window.pageYOffset;
    const distance = targetPosition - startPosition;
    const easing = easings[easingName] || easings.easeInOutCubic;
    let startTime = null;

    function animation(currentTime) {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);
      const easedProgress = easing(progress);

      window.scrollTo(0, startPosition + distance * easedProgress);

      if (timeElapsed < duration) {
        requestAnimationFrame(animation);
      }
    }

    requestAnimationFrame(animation);
  }

  /**
   * Extrait le hash d'une URL (gère les URLs complètes et les ancres simples)
   */
  function getHashFromHref(href) {
    if (!href) return null;

    // Si c'est une ancre simple (#section)
    if (href.startsWith("#")) {
      return href === "#" ? null : href.substring(1);
    }

    // Si c'est une URL complète avec hash
    try {
      const url = new URL(href, window.location.origin);
      // Vérifie que c'est sur le même domaine
      if (url.origin === window.location.origin && url.hash) {
        return url.hash.substring(1);
      }
    } catch (e) {
      return null;
    }

    return null;
  }

  /**
   * Gère le clic sur un lien ancre
   */
  function handleAnchorClick(e) {
    const href = this.getAttribute("href");
    const targetId = getHashFromHref(href);

    if (!targetId) return;

    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      e.preventDefault();

      // Calcule la position cible avec offset
      const targetPosition =
        targetElement.getBoundingClientRect().top +
        window.pageYOffset -
        CONFIG.offset;

      // Lance l'animation
      smoothScrollTo(targetPosition, CONFIG.duration, CONFIG.easing);

      // Met à jour l'URL sans recharger la page
      history.pushState(null, null, "#" + targetId);

      // Focus sur l'élément cible pour l'accessibilité
      targetElement.setAttribute("tabindex", "-1");
      targetElement.focus({ preventScroll: true });
    }
  }

  /**
   * Initialise le smooth scroll sur tous les liens ancre
   */
  function init() {
    // Sélectionne tous les liens ancre (simples #section ou URLs complètes avec hash)
    const anchorLinks = document.querySelectorAll('a[href^="#"], a[href*="#"]');

    anchorLinks.forEach((link) => {
      const href = link.getAttribute("href");
      // Ne traite que les liens avec un hash valide sur le même domaine
      if (getHashFromHref(href)) {
        link.addEventListener("click", handleAnchorClick);
      }
    });

    // Gère le scroll initial si l'URL contient un hash
    if (window.location.hash) {
      const targetElement = document.getElementById(
        window.location.hash.substring(1),
      );
      if (targetElement) {
        // Petit délai pour laisser la page se charger
        setTimeout(() => {
          const targetPosition =
            targetElement.getBoundingClientRect().top +
            window.pageYOffset -
            CONFIG.offset;
          smoothScrollTo(targetPosition, CONFIG.duration, CONFIG.easing);
        }, 100);
      }
    }
  }

  init();
});
